var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "5 -5 463 463",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-site,-Normal",
    transform: "translate(-160.000000, -383.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(160.000000, 383.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3:2",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 680,
    height: 151
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3:2-Copy",
    fill: "#061B79",
    x: 0,
    y: 151,
    width: 680,
    height: 151
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3:2-Copy-2",
    fill: "#C23729",
    x: 0,
    y: 302,
    width: 680,
    height: 151
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRu);
export default __webpack_public_path__ + "static/media/flag-ru.8099e0d04c5a1cca64c4843312629ee9.svg";
export { ForwardRef as ReactComponent };